import { getComponentByUUID } from '../screen'
import actions from './index'

export default ctx => action =>
  new Promise(resolve => {
    const component = ctx.store.getters['screen/component'](action.options.componentUUID)
    actions(ctx).execute({ uuid: action.options.componentUUID }, action.options.actions)
    resolve()
  })
